export const MITT_VACCIN_CLINICS_URL = "https://mittvaccin.se/mottagning"
